import { z } from "zod";
export const normalizationModeSchema = z.enum(["minmax", "rank"]);
export const featureWeightsSchema = z.record(z.string(), z.number());
export const analysisConfigSchema = z.object({
    minClusterSize: z.number(),
    nNeighbors: z.number(),
    minDist: z.number(),
    weights: featureWeightsSchema,
    normalization: normalizationModeSchema,
});
export const analysisStatusResponseSchema = z.object({
    scheduled: z.boolean(),
    intervalMinutes: z.number(),
    running: z.boolean(),
    config: analysisConfigSchema,
});
export const analysisConfigBodySchema = z.object({
    minClusterSize: z.number().optional(),
    nNeighbors: z.number().optional(),
    minDist: z.number().optional(),
    weights: featureWeightsSchema.optional(),
    normalization: normalizationModeSchema.optional(),
});
export const analysisConfigResponseSchema = z.object({
    config: analysisConfigSchema,
});
export const analysisTriggerResponseSchema = z.object({
    status: z.string(),
    output: z.string(),
});
export const featureStatSchema = z.object({
    name: z.string(),
    type: z.enum(["numeric", "categorical"]),
    unique: z.number(),
    min: z.number().optional(),
    max: z.number().optional(),
    mean: z.number().optional(),
    std: z.number().optional(),
    p25: z.number().optional(),
    p50: z.number().optional(),
    p75: z.number().optional(),
    p95: z.number().optional(),
    dominantPct: z.number().optional(),
    topValues: z
        .array(z.object({
        value: z.string(),
        count: z.number(),
        pct: z.number(),
    }))
        .optional(),
});
export const featureStatsResponseSchema = z.object({
    totalVectors: z.number(),
    features: z.array(featureStatSchema),
});
//# sourceMappingURL=analyze.js.map